import Relay from 'react-relay/classic';

export const userFrag = Relay.QL`
fragment on User {
  id
  allAssignedContent {
    __typename
    ... on Course {
      pid
      name
      description
      duration
      image
      coursePerformance {
        pid
        totalCards
        timeSpent
        scaledProgressMeasure
        completionStatus
        successStatus
        lastUpdatedTimeSpent
        lastVisitedCard {
          pid
          name
          globalPosition
          duration
        }
      }
      assignInfo{
        dueDate
        assignedDate
        assignedBy {
          pid
          name
        }
      }
    }
    ... on Curriculum {
      pid
      name
      description
      image
      courses{
        coursePerformance {
          completionStatus
          lastUpdatedTimeSpent
        }
      }
      curriculumPerformance {
        totalCourses
        courseCompleted
        duration
        totalTimeSpent
        lastVisitedCourse{
          pid
          name
          coursePerformance {
            lastUpdatedTimeSpent
            lastVisitedCard {
              pid
              name
              globalPosition
              duration
            }
          }
        }
      }
      assignInfoCurriculum {
        dueDate
        assignedDate
        assignedBy {
          pid
          name
        }
      }
    }
  }
  allUserCourses{
    pid
    name
    id
    coursePerformance {
      lastUpdatedTimeSpent
      id
      pid
      complete
      timeSpent
    }
    assignInfo{
      dueDate
    }
  }
}`;

export const courseFrag = Relay.QL`
fragment on Course {
  pid
  name
  image
  description
  totalCards
  totalAssignments
  courseTags{
    pid
    name
  }
  firstCard {
    pid
    name
    globalPosition
    duration
  }
  coursePerformance {
    pid
    successStatus
    visibleCompleted
    timeSpent
    scaledProgressMeasure
    lastUpdatedTimeSpent
    lastUpdated
    completionStatus
    lastVisitedCard {
      pid
      name
      globalPosition
      duration
      performance {
        lastUpdated
        scaledScore
        lastUpdatedTimeSpent
      }
    }
  }
  assignInfo {
    assignedBy {
      id
      pid
      name
      picture
    }
    dueDate
    assignedDate
  }
  teachers{
    id
    pid
    name
    picture
  }
  sections(first: 200) {
    edges {
      node {
        pid
        name
        cards(first:200){
          edges {
            node {
              id
              pid
              type
              duration
              contributeToSuccessStatus
              questionsForReview{
                pid
                currentReviewCount
                peerSubmissionsForReview(fetchReviewed: false) {
                  id
                  isReviewed
                  peerReview {
                    question
                    rType
                    rating
                    responseText
                    maxScore
                    question
                    rType
                    maxScore
                    options {
                      text
                      correct
                      relativeScore
                    }
                    options{
                      text
                      correct
                      relativeScore
                    }
                  }
                  answer{
                    response
                    thumbUrl
                    answerType
                  }
                  user{
                    id
                    pid
                    name
                    picture
                    realEmail
                  }
                }
              }
              questionAnswers(userId: $userId) {
                pid
                q
                rType
                rTypeSecondary
                rawScore
                minScore
                maxScore
                gradingScheme
                peerQuestions(userId: $userId) {
                  question
                  reviewsReceived {
                    reviewedBy {
                      pid
                    }
                  }
                }
                options{
                  text
                  correct
                }
                topRatedResponses {
                  answer {
                    response
                    answerType
                  }
                  user {
                    name
                    picture
                  }
                }
                answer{
                  id
                  pid
                  evaluatedAnswer
                  response
                  lastUpdatedResponse
                  thumbUrl
                  answerType
                  feedback
                  gradedBy {
                    pid
                    name
                    picture
                  }
                  feedbackGivenBy {
                    pid
                    name
                    picture
                  }
                }
              }
              resource {
                type
                content {
                  questions {
                    rType
                  }
                }
                narrationUrl
              }
              hideMarkComplete
              maxScore
              performance(userId: $userId) {
                id
                completionStatus
                timeSpent
                successStatus
                reAttemptCount
                actualSubmit
                progressMeasure
                scaledProgressMeasure
                rawScore
                lastUpdatedTimeSpent
                lastUpdatedComplete
                forceComplete
                complete
                lastUpdated
                scaledScore
                scorm{
                  score_raw
                  mastery_score
                  scormData
                }
              }
              resource {
                type
                content {
                  data
                  url
                  thumbUrl
                }
                narrationUrl
              }
            }
          }
        }
      }
    }
  }
}`;
